// extracted by mini-css-extract-plugin
export default {"galleryHeader":"c-l_if"};